import { API_HOST } from 'src/constants';

export const V2026_BASE = `${API_HOST}/api/acr-merge/v2026/`;

export function publicationPeriodsUrl(): string {
  return `${V2026_BASE}periods/`;
}
